module.exports = __webpack_public_path__ + "b58a17681c403e5db3f9d2adba3538d0.svg";